import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function LinkedCleanupDialog({ open, onOpenChange, orderId, dropReship, dropRvp, onDecision }) {
  const items = [];
  if (dropRvp) items.push("the reverse pickup created for this order");
  if (dropReship) items.push("the new shipment created for this order");
  const many = items.length > 1;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="linked-cleanup-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <span className="h-8 w-8 rounded-lg bg-[#FBE4DC] text-[#C24127] flex items-center justify-center">
              <AlertTriangle className="h-4 w-4" />
            </span>
            Delete linked follow-up?
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          You changed the final action for order{orderId ? ` #${orderId}` : ""}. {items.join(" and ")}{" "}
          {many ? "were" : "was"} already created. Do you want to delete {many ? "them" : "it"}?
        </p>
        <DialogFooter className="gap-2">
          <Button variant="outline" data-testid="cleanup-keep" onClick={() => onDecision(false)}>
            No, keep {many ? "them" : "it"}
          </Button>
          <Button data-testid="cleanup-delete" onClick={() => onDecision(true)}
                  className="bg-[#C24127] hover:bg-[#a5341f] text-white">
            Yes, delete {many ? "them" : "it"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
